/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { onFCP, onLCP, onCLS, onINP, onTTFB } from "web-vitals";
import { reportWebVitals } from "./reportWebVitals";

export function initWebVitals() {
  if ("performance" in window && "PerformanceObserver" in window) {
    onFCP((metric) => {
      reportWebVitals("FCP", metric.value);
    });

    onLCP((metric) => {
      reportWebVitals("LCP", metric.value);
    });

    onCLS((metric) => {
      reportWebVitals("CLS", metric.value);
    });

    // NF-1: onFID() removed in web-vitals v4 — replaced with onINP() (Interaction to Next Paint).
    // INP is the Core Web Vital that replaced FID as the responsiveness metric (March 2024).
    onINP((metric) => {
      reportWebVitals("INP", metric.value);
    });

    onTTFB((metric) => {
      reportWebVitals("TTFB", metric.value);
    });
  }
}
